import ajax from './../ajax';

export function createStudent(
  name,
  email,
  phone,
  dob,
  gender,
  city,
  hear_about_us,
  current_status,
  student_studying_profile,
  student_working_profile,
  student_looking_job_profile,
  student_confused_profile,
  course_level_id
) {
  return ajax('/students', {
    method: 'POST',
    body: {
      course_level_id,
      student: {
        name,
        email,
        phone,
        dob,
        gender,
        city,
        hear_about_us,
        current_status,
        student_studying_profile,
        student_working_profile,
        student_looking_job_profile,
        student_confused_profile
      }
    }
  });
}



// WEBPACK FOOTER //
// ./src/api/v1/student.js